import { type FC, type ReactNode, useState, useCallback } from 'react';
import { graphql, useFragment } from 'react-relay';

import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { BuyerIncentivesBanner } from 'dibs-buyer-incentives/exports/BuyerIncentivesBanner.ts';

import { useServerVarsContext } from '../../../global/ServerVarsContext/ServerVarsContext.tsx';
import { PdpSharedDibsPromiseModalLazy } from '../../PdpSharedModals/PdpSharedDibsPromiseModal/PdpSharedDibsPromiseModalLazy.tsx';
import { useIsSellerBrandingV2Variant } from '../../helpers/sellerBrandingV2TestHelpers.ts';

import { type PdpSharedSidebarBuyerIncentives_user$key } from './__generated__/PdpSharedSidebarBuyerIncentives_user.graphql.ts';

const userFragment = graphql`
    fragment PdpSharedSidebarBuyerIncentives_user on User {
        ...PdpSharedDibsPromiseModalLazy_user
    }
`;

const PdpSharedSidebarBuyerIncentives: FC<{
    user?: PdpSharedSidebarBuyerIncentives_user$key | null | undefined;
}> = ({ user: userRef }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const user = useFragment(userFragment, userRef);
    const { isMobile } = useServerVarsContext();
    const isSellerBrandingV2Variant = useIsSellerBrandingV2Variant();

    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true);
        trackEvent({
            eventName: eventNameConstants.EVENT_PRODUCT_INTERACTION,
            interaction_type: interactionTypeConstants.INTERACTION_TYPE_EBI_DETAILS,
            step_interaction_name:
                stepInteractionConstants.STEP_INTERACTION_EBI_SIDERAIL_DETAILS_CLICK,
        });
    }, []);

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    const getLink = (chunk: ReactNode): ReactNode => {
        return (
            <Link dataTn="dibs-promise-link" href="#" onClick={handleOpenModal}>
                {chunk}
            </Link>
        );
    };

    return (
        <>
            <BuyerIncentivesBanner
                linkPosition="bottom"
                getLink={getLink}
                isMobile={!!isMobile}
                isTrustMessagingTest2Variant={isSellerBrandingV2Variant}
            />
            <PdpSharedDibsPromiseModalLazy
                user={user}
                isOpen={isModalOpen}
                onClose={handleCloseModal}
            />
        </>
    );
};

export default PdpSharedSidebarBuyerIncentives;
